module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm3.66 20.838a1.043 1.043 0 0 1 0 1.43l-1.368 1.434a.933.933 0 0 1-1.368 0l-6.642-6.96a1.053 1.053 0 0 1 0-1.434l6.7-7.014a.94.94 0 0 1 1.368 0l1.368 1.434a1.046 1.046 0 0 1 0 1.432l-4.648 4.868 4.59 4.81z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/left-circle-2.js
// module id = 1221
// module chunks = 14